import script from "./GradeClassChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeClassChart.vue?vue&type=script&setup=true&lang=js"

import "./GradeClassChart.vue?vue&type=style&index=0&id=61b2951c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b2951c"]])

export default __exports__